// from age 3
const oxfordParameters = {
  Oxford_Man_A: [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    545,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    593,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
    514,
  ],
  Oxford_Man_B: [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    14.2,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
    13.5,
  ],
  Oxford_Woman_A: [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    554,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    694,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
    569,
  ],
  Oxford_Woman_B: [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    13.1,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    9.74,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
    10.1,
  ],
};

const RobertsonReidParameters = {
  Male_Mean: [
    60.1, 57.9, 56.3, 54.2, 52.1, 50.1, 48.2, 46.6, 45.1, 43.8, 42.7, 41.8, 41, 40.3, 39.7, 39.2,
    38.8, 38.4, 38.1, 37.8, 37.6, 37.3, 37.1, 37, 36.8, 36.6, 36.5, 36.4, 36.3, 36.2, 36.1, 36,
    35.9, 35.8, 35.7, 35.7, 35.6, 35.5, 34.5, 34.5, 34.5, 34.5, 34.1, 34.1, 34.1, 34.1, 34.1, 33.8,
    33.8, 33.8, 33.8, 33.8, 33.4, 33.4, 33.4, 33.4, 33.4, 33.1, 33.1, 33.1, 33.1, 33.1, 32.7, 32.7,
    32.7, 32.7, 32.7, 32.5, 32.5, 32.5, 32.5, 32.5, 32, 32, 32, 32, 32, 32,
  ],
  Male_Low: [
    51.5, 49.2, 47.7, 45.6, 43.4, 41.4, 39.6, 38.6, 37.7, 36.8, 36, 35.2, 34.4, 33.7, 33.1, 32.9,
    32.7, 32.6, 32.5, 32.4, 32.3, 32.2, 32.1, 32, 31.8, 31.6, 31.5, 31.4, 31.3, 31.2, 31.1, 31,
    30.9, 30.8, 30.7, 30.7, 30.6, 30.5, 29.5, 29.5, 29.5, 29.5, 29.1, 29.1, 29.1, 29.1, 29.1, 28.8,
    28.8, 28.8, 28.8, 28.8, 28.4, 28.4, 28.4, 28.4, 28.4, 28.1, 28.1, 28.1, 28.1, 28.1, 27.7, 27.7,
    27.7, 27.7, 27.7, 27.4, 27.4, 27.4, 27.4, 27.4, 27, 27, 27, 27, 27, 27,
  ],
  Male_High: [
    68.8, 66.5, 65, 62.8, 60.7, 58.7, 56.7, 54.4, 52.2, 50.4, 49.3, 48.4, 47.6, 46.9, 46.3, 45.6,
    45, 44.3, 43.7, 43.1, 42.6, 42.3, 42.1, 42, 41.8, 41.6, 41.5, 41.4, 41.3, 41.2, 41.1, 41, 40.9,
    40.8, 40.7, 40.7, 40.6, 40.5, 39.5, 39.5, 39.5, 39.5, 39.1, 39.1, 39.1, 39.1, 39.1, 38.8, 38.8,
    38.8, 38.8, 38.8, 38.4, 38.4, 38.4, 38.4, 38.4, 38.1, 38.1, 38.1, 38.1, 38.1, 37.7, 37.7, 37.7,
    37.7, 37.7, 37.4, 37.4, 37.4, 37.4, 37.4, 37, 37, 37, 37, 37, 37,
  ],
  Female_Mean: [
    54.5,
    53.9,
    53,
    51.8,
    50.2,
    48.4,
    46.4,
    44.3,
    42.4,
    40.6,
    39.1,
    37.8,
    36.8,
    36,
    35.3,
    34.9,
    34.5,
    34.3,
    34.1,
    34,
    34,
    33.9,
    34,
    34,
    34,
    34,
    34.1,
    34.1,
    34,
    33.9,
    33.8,
    33.7,
    33.5,
    33.3,
    33.1,
    32.9,
    32.8,
    32.8,
    32.5,
    32.5,
    32.5,
    32.5,
    32.2,
    32.2,
    32.2,
    32.2,
    32.2,
    31.9,
    31.9,
    31.9,
    31.9,
    31.9,
    31.6,
    31.6,
    31.6,
    31.6,
    31.6,
    31.3,
    31.3,
    31.3,
    31.3,
    31.3,
    31,
    31,
    31,
    31,
    31,
    30.7,
    30.7,
    30.7,
    30.7,
    30.7,
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
  Female_Low: [
    46.4,
    45.8,
    44.9,
    43.6,
    42.1,
    40.2,
    38.2,
    36.3,
    35.1,
    34,
    33.2,
    32.6,
    32.2,
    31.3,
    30.7,
    30.1,
    29.7,
    29.5,
    29.3,
    29.2,
    29.1,
    29.1,
    29.1,
    29.2,
    29.2,
    29.2,
    29.2,
    29.2,
    29.2,
    29.1,
    29,
    28.9,
    28.7,
    28.5,
    28.3,
    28,
    28,
    27.8,
    27.7,
    27.7,
    27.7,
    27.7,
    27.7,
    27.4,
    27.4,
    27.4,
    27.4,
    27.1,
    27.1,
    27.1,
    27.1,
    27.1,
    26.8,
    26.8,
    26.8,
    26.8,
    26.8,
    26.5,
    26.5,
    26.5,
    26.5,
    26.5,
    26.2,
    26.2,
    26.2,
    26.2,
    26.2,
    25.9,
    25.9,
    25.9,
    25.9,
    25.9,
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
  Female_High: [
    62.6,
    62.1,
    61.1,
    59.9,
    58.3,
    56.5,
    54.5,
    52.5,
    50.6,
    47.7,
    45.1,
    42.7,
    41.7,
    40.8,
    40.2,
    39.7,
    39.3,
    39.1,
    38.9,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.8,
    38.7,
    38.5,
    38.3,
    38.2,
    38,
    37.7,
    37.6,
    37.5,
    37.4,
    37.4,
    37.4,
    37.4,
    37.1,
    37.1,
    37.1,
    37.1,
    37.1,
    36.7,
    36.7,
    36.7,
    36.7,
    36.7,
    36.4,
    36.4,
    36.4,
    36.4,
    36.4,
    36.1,
    36.1,
    36.1,
    36.1,
    36.1,
    35.8,
    35.8,
    35.8,
    35.8,
    35.8,
    35.5,
    35.5,
    35.5,
    35.5,
    35.5,
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
};

export { oxfordParameters, RobertsonReidParameters };
